import lucene from 'lucene';
import type {QueryToken, TermQueryToken, RangeQueryToken} from './types';

const parseField = (field: string): string | null | undefined => {
	return !field || field === '<implicit>' ? null : field;
};

const parseFieldQueryToken = (ast: Record<string, any>, groupField: string | null | undefined): TermQueryToken => {
	const field = parseField(ast.field) || groupField;
	const {term} = ast;

	if (field) {
		return {
			type: 'TERM',
			term,
			field
		};
	} else {
		return {
			type: 'TERM',
			term
		};
	}
};

const parseRangeQueryToken = (ast: Record<string, any>, groupField: string | null | undefined): RangeQueryToken => {
	const field = parseField(ast.field) || groupField;
	const {term_min, term_max, inclusive} = ast;

	if (field) {
		return {
			type: 'RANGE',
			termMin: term_min,
			termMax: term_max,
			inclusive,
			field
		};
	} else {
		return {
			type: 'RANGE',
			termMin: term_min,
			termMax: term_max,
			inclusive
		};
	}
};

const parseAST = (ast: Record<string, any>, groupField: string | null | undefined): Array<QueryToken> => {
	if (ast.left || ast.right) {
		const tokens = [];
		const field = parseField(ast.field);

		if (ast.left) {
			tokens.push(...parseAST(ast.left, field));
		}

		if (ast.right) {
			tokens.push(...parseAST(ast.right, field));
		}

		return tokens;
	} else if (ast.term) {
		return [parseFieldQueryToken(ast, groupField)];
	} else {
		return [parseRangeQueryToken(ast, groupField)];
	}
};

export const parse = (query: string): Array<QueryToken> | null | undefined => {
	if (!query || !query.trim().length || query.trim().endsWith(':')) {
		return [];
	}

	try {
		const ast = lucene.parse(query);
		return parseAST(ast, undefined);
	} catch (e) {
		console.warn('cannot parse query:', query);
		return null;
	}
};
